import React from "react";
import { Fragment, EditOp, CreateOp } from "core/models/Fragment";
import { IconNames } from "core/models";
import { Tooltip, Icon } from "ui/components";
import styles from "./FlagBar.module.scss";

interface Props {
    fragment: Fragment;
}
interface Flag {
    text: string;
    icon: IconNames;
}

const instanceOfCreate = (data: any): data is CreateOp => "fromfile" in data;
const instanceOfEdit = (data: any): data is EditOp => "cropped" in data;

const FlagBar: React.FC<Props> = ({ fragment }: Props) => {
    const aspectRatio = fragment.getAspectRatio();
    let flagArr: Flag[] = [];
    fragment.properties.forEach((prop) => {
        if (prop.key === "spoton-createop") {
            if (instanceOfCreate(prop.value) && prop.value.iscompilation) {
                flagArr.push({ icon: "compilation", text: "Compilation" });
            }
            if (instanceOfCreate(prop.value) && prop.value.fromfile) {
                flagArr.push({ icon: "upload", text: "Uploaded" });
            }
        }
        if (prop.key === "spoton-editop") {
            if (instanceOfEdit(prop.value) && prop.value.cropped) {
                flagArr.push({ icon: "crop", text: "Cropped" });
            }
            if (instanceOfEdit(prop.value) && prop.value.introkey) {
                flagArr.push({ icon: "pre-roll", text: "Intro" });
            }
            if (instanceOfEdit(prop.value) && prop.value.isduplicate) {
                flagArr.push({ icon: "copy", text: "Duplicate" });
            }

            if (instanceOfEdit(prop.value) && prop.value.outrokey) {
                flagArr.push({ icon: "post-roll", text: "Outro" });
            }
            if (instanceOfEdit(prop.value) && prop.value.overlaykey) {
                flagArr.push({ icon: "overlay", text: "Overlay" });
            }
            if (instanceOfEdit(prop.value) && prop.value.padded) {
                flagArr.push({ icon: "resize", text: "Scaled" });
            }
            if (instanceOfEdit(prop.value) && prop.value.trimmed) {
                flagArr.push({ icon: "trim", text: "Trimmed" });
            }
        }
    });
    if (aspectRatio) {
        flagArr.unshift({
            icon: "crop-empty",
            text: `Aspectratio: ${aspectRatio}`,
        });
    }
    if (fragment.hasSubtitles()) {
        flagArr.push({ icon: "subtitles", text: "Captions" });
    }
    flagArr = flagArr.filter((el) => el !== undefined);

    return (
        <div className={styles.flagbar}>
            {flagArr.map((flag) => (
                    <Tooltip
                        key={flag.icon}
                        text={flag.text}
                        className={styles.flagbar__flag}
                    >
                        <Icon name={flag.icon} />
                    </Tooltip>
                ))}
        </div>
    );
};

export default React.memo(FlagBar);
